/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as GetStartedRouteImport } from "./routes/get-started"
import { Route as IntakeRouteImport } from "./routes/intake"
import { Route as SensoryProfileRouteImport } from "./routes/sensory-profile"
import { Route as IntakeIndexRouteImport } from "./routes/intake/index"
import { Route as IntakeStepIdRouteImport } from "./routes/intake/$stepId"
import { Route as IntakeSubmittedRouteImport } from "./routes/intake/submitted"
import { Route as SensoryProfileIndexRouteImport } from "./routes/sensory-profile/index"
import { Route as SensoryProfileStepIdRouteImport } from "./routes/sensory-profile/$stepId"
import { Route as SensoryProfileSubmittedRouteImport } from "./routes/sensory-profile/submitted"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const GetStartedRoute = GetStartedRouteImport.update({
  id: "/get-started",
  path: "/get-started",
  getParentRoute: () => rootRouteImport,
} as any)
const IntakeRoute = IntakeRouteImport.update({
  id: "/intake",
  path: "/intake",
  getParentRoute: () => rootRouteImport,
} as any)
const SensoryProfileRoute = SensoryProfileRouteImport.update({
  id: "/sensory-profile",
  path: "/sensory-profile",
  getParentRoute: () => rootRouteImport,
} as any)
const IntakeIndexRoute = IntakeIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => IntakeRoute,
} as any)
const IntakeStepIdRoute = IntakeStepIdRouteImport.update({
  id: "/$stepId",
  path: "/$stepId",
  getParentRoute: () => IntakeRoute,
} as any)
const IntakeSubmittedRoute = IntakeSubmittedRouteImport.update({
  id: "/submitted",
  path: "/submitted",
  getParentRoute: () => IntakeRoute,
} as any)
const SensoryProfileIndexRoute = SensoryProfileIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => SensoryProfileRoute,
} as any)
const SensoryProfileStepIdRoute = SensoryProfileStepIdRouteImport.update({
  id: "/$stepId",
  path: "/$stepId",
  getParentRoute: () => SensoryProfileRoute,
} as any)
const SensoryProfileSubmittedRoute = SensoryProfileSubmittedRouteImport.update({
  id: "/submitted",
  path: "/submitted",
  getParentRoute: () => SensoryProfileRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/get-started": typeof GetStartedRoute
  "/intake": typeof IntakeRouteWithChildren
  "/sensory-profile": typeof SensoryProfileRouteWithChildren
  "/intake/$stepId": typeof IntakeStepIdRoute
  "/intake/submitted": typeof IntakeSubmittedRoute
  "/sensory-profile/$stepId": typeof SensoryProfileStepIdRoute
  "/sensory-profile/submitted": typeof SensoryProfileSubmittedRoute
  "/intake/": typeof IntakeIndexRoute
  "/sensory-profile/": typeof SensoryProfileIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/get-started": typeof GetStartedRoute
  "/intake/$stepId": typeof IntakeStepIdRoute
  "/intake/submitted": typeof IntakeSubmittedRoute
  "/sensory-profile/$stepId": typeof SensoryProfileStepIdRoute
  "/sensory-profile/submitted": typeof SensoryProfileSubmittedRoute
  "/intake": typeof IntakeIndexRoute
  "/sensory-profile": typeof SensoryProfileIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/get-started": typeof GetStartedRoute
  "/intake": typeof IntakeRouteWithChildren
  "/sensory-profile": typeof SensoryProfileRouteWithChildren
  "/intake/$stepId": typeof IntakeStepIdRoute
  "/intake/submitted": typeof IntakeSubmittedRoute
  "/sensory-profile/$stepId": typeof SensoryProfileStepIdRoute
  "/sensory-profile/submitted": typeof SensoryProfileSubmittedRoute
  "/intake/": typeof IntakeIndexRoute
  "/sensory-profile/": typeof SensoryProfileIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/get-started"
    | "/intake"
    | "/sensory-profile"
    | "/intake/$stepId"
    | "/intake/submitted"
    | "/sensory-profile/$stepId"
    | "/sensory-profile/submitted"
    | "/intake/"
    | "/sensory-profile/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/get-started"
    | "/intake/$stepId"
    | "/intake/submitted"
    | "/sensory-profile/$stepId"
    | "/sensory-profile/submitted"
    | "/intake"
    | "/sensory-profile"
  id:
    | "__root__"
    | "/"
    | "/get-started"
    | "/intake"
    | "/sensory-profile"
    | "/intake/$stepId"
    | "/intake/submitted"
    | "/sensory-profile/$stepId"
    | "/sensory-profile/submitted"
    | "/intake/"
    | "/sensory-profile/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  GetStartedRoute: typeof GetStartedRoute
  IntakeRoute: typeof IntakeRouteWithChildren
  SensoryProfileRoute: typeof SensoryProfileRouteWithChildren
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/get-started": {
      id: "/get-started"
      path: "/get-started"
      fullPath: "/get-started"
      preLoaderRoute: typeof GetStartedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/intake": {
      id: "/intake"
      path: "/intake"
      fullPath: "/intake"
      preLoaderRoute: typeof IntakeRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/sensory-profile": {
      id: "/sensory-profile"
      path: "/sensory-profile"
      fullPath: "/sensory-profile"
      preLoaderRoute: typeof SensoryProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/intake/": {
      id: "/intake/"
      path: "/"
      fullPath: "/intake/"
      preLoaderRoute: typeof IntakeIndexRouteImport
      parentRoute: typeof IntakeRoute
    }
    "/intake/$stepId": {
      id: "/intake/$stepId"
      path: "/$stepId"
      fullPath: "/intake/$stepId"
      preLoaderRoute: typeof IntakeStepIdRouteImport
      parentRoute: typeof IntakeRoute
    }
    "/intake/submitted": {
      id: "/intake/submitted"
      path: "/submitted"
      fullPath: "/intake/submitted"
      preLoaderRoute: typeof IntakeSubmittedRouteImport
      parentRoute: typeof IntakeRoute
    }
    "/sensory-profile/": {
      id: "/sensory-profile/"
      path: "/"
      fullPath: "/sensory-profile/"
      preLoaderRoute: typeof SensoryProfileIndexRouteImport
      parentRoute: typeof SensoryProfileRoute
    }
    "/sensory-profile/$stepId": {
      id: "/sensory-profile/$stepId"
      path: "/$stepId"
      fullPath: "/sensory-profile/$stepId"
      preLoaderRoute: typeof SensoryProfileStepIdRouteImport
      parentRoute: typeof SensoryProfileRoute
    }
    "/sensory-profile/submitted": {
      id: "/sensory-profile/submitted"
      path: "/submitted"
      fullPath: "/sensory-profile/submitted"
      preLoaderRoute: typeof SensoryProfileSubmittedRouteImport
      parentRoute: typeof SensoryProfileRoute
    }
  }
}

interface IntakeRouteChildren {
  IntakeStepIdRoute: typeof IntakeStepIdRoute
  IntakeSubmittedRoute: typeof IntakeSubmittedRoute
  IntakeIndexRoute: typeof IntakeIndexRoute
}

const IntakeRouteChildren: IntakeRouteChildren = {
  IntakeStepIdRoute: IntakeStepIdRoute,
  IntakeSubmittedRoute: IntakeSubmittedRoute,
  IntakeIndexRoute: IntakeIndexRoute,
}

const IntakeRouteWithChildren =
  IntakeRoute._addFileChildren(IntakeRouteChildren)

interface SensoryProfileRouteChildren {
  SensoryProfileStepIdRoute: typeof SensoryProfileStepIdRoute
  SensoryProfileSubmittedRoute: typeof SensoryProfileSubmittedRoute
  SensoryProfileIndexRoute: typeof SensoryProfileIndexRoute
}

const SensoryProfileRouteChildren: SensoryProfileRouteChildren = {
  SensoryProfileStepIdRoute: SensoryProfileStepIdRoute,
  SensoryProfileSubmittedRoute: SensoryProfileSubmittedRoute,
  SensoryProfileIndexRoute: SensoryProfileIndexRoute,
}

const SensoryProfileRouteWithChildren = SensoryProfileRoute._addFileChildren(
  SensoryProfileRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  GetStartedRoute: GetStartedRoute,
  IntakeRoute: IntakeRouteWithChildren,
  SensoryProfileRoute: SensoryProfileRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
